import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '@shripos/shared/constants';
import { cn } from '@shripos/ui';
import { setLanguage } from '../i18n/index.js';

/**
 * English / हिन्दी / తెలుగు. Staff screens (billing, PIN, kitchen, cash) and the self-order
 * screens are translated; owner screens (settings, reports, menu) stay in English.
 * `remember: false` changes the language for this session only (self-order customers).
 */
export function LanguagePicker({ className, size = 'sm', remember = true }) {
  const { i18n, t } = useTranslation();
  return (
    <div className={cn('flex gap-1', className)} role="radiogroup" aria-label={t('common.language', 'Language')}>
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          role="radio"
          aria-checked={i18n.language === l.code}
          lang={l.code}
          onClick={() => (remember ? setLanguage(l.code) : i18n.changeLanguage(l.code))}
          className={cn(
            'rounded-md font-medium',
            size === 'lg' ? 'px-4 py-2 text-base' : 'px-2 py-1 text-xs',
            i18n.language === l.code ? 'bg-brand-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200',
          )}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
